import { createContext } from 'react'

export const TabTitleContext = createContext('')
